import { Typography } from '@mui/material'
import React, { ComponentPropsWithRef, useContext } from 'react'
import { Icons } from '../../assets/icons'
import { DraggableAssignationList } from '../../components/dnd/DraggableAssignationList'
import { toBoldStrings, useTranslation } from '../../i18n/useTranslation'
import { useCommonCtx } from '../../context/useCommonCtx'
import { MainTitle } from '../../components/MainTitle'

interface Props extends ComponentPropsWithRef<'div'> {}

/**
 * RANK_FOR_ROUND + OVERVIEW (=PROFILE/PREFERENCES) any time
 * @param p 
 * @returns 
 */
export const RankForRound = (p: Props) => {
    const { className, ...rest } = p
    const commons = useCommonCtx()
    const t = useTranslation(commons)
    return (
        <div className={
            'flex flex-1 flex-col justify-between items-center px-4'
        }>
            <MainTitle title={t('hint_reorder')} />
            <Typography
                variant="h6"
                className="flex self-stretch justify-end text-right font-bold items-center mb-1 mt-2"
            >
                {toBoldStrings(t('top_scale_hint')).map((s, i, arr) => (
                    <Typography
                        className={`${i % 2 === 1 ? 'font-bold ' : ''} ${
                            i < arr.length - 1 ? 'mr-2' : ''
                        }`}
                        key={i}
                    >
                        {s}
                    </Typography>
                ))}
                <Icons.Top />
            </Typography>
            {/*  */}
            <DraggableAssignationList
                stmProps={() => ({
                    fontType: 'small',
                    showRank: true,
                    showId: commons.state.params.assessmentParams['debug_mode'] === 1,
                })}
                //  FIXME change d&n with scroll
                items={[
                    ...commons.items2rank,
                ]}
                setItems={(as) => commons.setItems2rank(as)}
            />
            {/* FIXME component*/}
            <Typography
                variant="h6"
                className="flex self-stretch justify-end text-right font-bold items-center mt-1 mb-2"
            >
                {toBoldStrings(t('bottom_scale_hint')).map((s, i, arr) => (
                    <Typography
                        className={`${i % 2 === 1 ? 'font-bold ' : ''} ${
                            i < arr.length - 1 ? 'mr-2' : ''
                        }`}
                        key={i}
                    >
                        {s}
                    </Typography>
                ))}
                <Icons.Bottom />
            </Typography>
        </div>
    )
}
